import { Breadcrumbs, withStyles } from '@material-ui/core';
import styles from './styles';

export default withStyles(styles)(Breadcrumbs);
